import { render } from "./ExamCard.vue?vue&type=template&id=bd384570&scoped=true"
import script from "./ExamCard.vue?vue&type=script&lang=js"
export * from "./ExamCard.vue?vue&type=script&lang=js"

import "./ExamCard.vue?vue&type=style&index=0&id=bd384570&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd384570"]])

export default __exports__